import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

function ProductForm({ productId, onClose }) {
  const [formData, setFormData] = useState({
    name: '',
    purchase_price: '',
    retail_price_70k: ''
  });
  const [loading, setLoading] = useState(false);

  const fetchProduct = useCallback(async () => {
    try {
      const response = await axios.get(`/api/products/${productId}`);
      setFormData(response.data);
    } catch (error) {
      console.error('Error fetching product:', error);
    }
  }, [productId]);

  useEffect(() => {
    if (productId) {
      fetchProduct();
    }
  }, [productId, fetchProduct]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      if (productId) {
        await axios.put(`/api/products/${productId}`, formData);
      } else {
        await axios.post('/api/products', formData);
      }
      onClose();
    } catch (error) {
      console.error('Error saving product:', error);
      alert('Lỗi khi lưu sản phẩm');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal show">
      <div className="modal-content">
        <div className="modal-header">
          <h3 className="modal-title">{productId ? 'Sửa sản phẩm' : 'Thêm sản phẩm'}</h3>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        <form onSubmit={handleSubmit} className="modal-body">
          <div className="form-group">
            <label>Tên sản phẩm</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Giá nhập (₫)</label>
            <input
              type="number"
              name="purchase_price"
              value={formData.purchase_price}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Giá bán lẻ (₫)</label>
            <input
              type="number"
              name="retail_price_70k"
              value={formData.retail_price_70k}
              onChange={handleChange}
              required
            />
          </div>
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
            <button type="button" onClick={onClose} style={{ background: '#999' }}>Hủy</button>
            <button type="submit" disabled={loading}>
              {loading ? 'Đang lưu...' : 'Lưu'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ProductForm;
